<template>
	<BaseCmsRotator @loadRotatorItems="onLoad" :fetch="{code: 'hello_bar', limit: 1}" v-slot="{items}">
	
		<div v-if="items?.length && !isHidden" class="hello-bar">
			<div class="hello-bar-wrapper wider-wrapper" :class="{'no-counter': !item.date_active_to}" v-for="item in items" :key="item.id">
				<div class="hello-bar-image" v-if="item.image_upload_path">
					<BaseUiImage :data="item.image_thumbs?.['width76-height64-crop1']" default="/images/no-image-76.jpg" loading="lazy" />
				</div>
				<div class="hello-bar-content">
					<div class="hello-bar-desc" v-html="item.content" v-interpolation v-if="item?.content"></div>
					<div class="hello-bar-subtitle" v-html="item.title2" v-interpolation v-if="item?.title2"></div>
				</div>
				
				<BaseAuthCoupons v-slot="{onActivate, activatedCoupons}">
					<div class="hello-bar-coupon-cnt" :class="{active: activatedCoupons?.length && activatedCoupons.includes(item.coupon_code)}" v-if="item?.coupon_code">
						
						<div class="activated-coupon-note" v-if="item?.element_hellobar_message_content">
							{{ item.element_hellobar_message_content }}
						</div>					

						<div
							class="hellobar-coupon-btn"
							@click="activatedCoupons?.length && activatedCoupons.includes(item.coupon_code) ? '' : onActivate(item.coupon_code)"
							:data-list_link="item.element_hellobar_message_button_link || ''"
						>
							<BaseCmsLabel code="hellobar_coupon_title_inactive" class="i" tag="span" />
							<BaseCmsLabel code="hellobar_coupon_title_active" class="a" tag="span" />
						</div>
					</div>

					<div class="hello-bar-timer-cnt" :class="{'active-coupon': activatedCoupons?.length && activatedCoupons.includes(item.coupon_code)}" v-if="item?.date_active_to">
						<BaseUiCountdown :end="item.date_active_to" v-slot="{days, hours, minutes, seconds, ended}">
							<div class="hello-bar-timer" v-if="!ended">
								<div v-if="days && days > 0" class="days">
									<span>{{ days }}</span> d
								</div>
								<div class="hour">
									<span>{{ hours }}</span> h
								</div>
								<div class="min">
									<span>{{ minutes }}</span> m
								</div>
								<div class="sec">
									<span>{{ seconds }}</span> s
								</div>
							</div>
						</BaseUiCountdown>
					</div>
				</BaseAuthCoupons>
			</div>
			<div class="hello-bar-close" @click="close"></div>
		</div>
	</BaseCmsRotator>
</template>

<script setup>
	const isHidden = ref(true);
	let rotatorItemId = 0;

	function onLoad(data) {
		rotatorItemId = data?.items?.[0]?.id;
		const cookie = useCookie('hello_bar_'+rotatorItemId);
		if(!cookie.value) {
			isHidden.value = false;
		}
	}

	function close() {
		const cookie = useCookie('hello_bar_'+rotatorItemId, {
			maxAge: 60 * 60 * 24 * 30 // 1 month
		});
		cookie.value = 1;
		isHidden.value = true;
	}
</script>

<style lang="less" scoped>
	.hello-bar{
		background: var(--textColor); display: flex; overflow: hidden; position: relative; z-index: 1; height: 96px;
		@media (max-width: @tp){height: auto;}
	}
	.no-counter{
		justify-content: center;
		.hello-bar-image{position: absolute; left: 0; right: 16px; margin-right: 0;}
		.hello-bar-content{margin: auto; text-align: center;}
		@media (max-width: @tp){
			.hello-bar-wrapper{padding: 12px 0 10px;}
		}
	}
	
	.hello-bar-wrapper{
		display: flex; align-items: center; min-height: 96px; position: relative;
		@media (max-width: @l){padding-right: 15px;}
		@media (max-width: @t){width: 100%;}
		@media (max-width: @tp){padding: 8px 0; min-height: 0; flex-flow: column;}
	}
	.hello-bar-image{
		margin-right: 32px; display: block; position: relative; display: block;
		:deep(img){display: block; width: 100%; height: auto; max-width: 76px; max-height: 64px;}
		@media (max-width: @l){margin-right: 15px;}
		@media (max-width: @tp){display: none;}
		/* @media (max-width: @m){
			margin-right: 0; width: 100%;
			:deep(img){max-height: 100%;}
			&:after{.pseudo(auto, 1px); background: var(--colorWhite); bottom: 0; right: 0; left: 0;}
		} */
	}
	.hello-bar-content{
		font-size: 18px; line-height: 1.3; color: var(--white); display: flex; flex-flow: column; margin-right: auto;
		:deep(p){padding-bottom: 0;}
		:deep(a){
			font-weight: bold; color: var(--white); text-underline-offset: 3px; .transition();
			&:hover{color: var(--white); text-decoration-color: transparent;}
		}
		@media (max-width: @t){font-size: 16px; line-height: 1.3;}
		@media (max-width: @tp){margin-right: unset; width: 100%; align-items: center; order: 2; padding: 2px 20px 4px; text-align: center;}
	}
	.hello-bar-desc{
		font-size: 24px; line-height: 32px;
		@media (max-width: @t){font-size: 18px; line-height: 21px;}
		@media (max-width: @tp){padding-bottom: 4px;}
	}

	//Coupon
	.hello-bar-coupon-cnt{
		display: flex; align-items: center; flex-shrink: 0; position: relative;
		&.active{
			.activated-coupon-note{display: block;}
			.hellobar-coupon-btn{
				background: #D4C9DE; padding: 0 56px 0 20px;
				&:before{left: auto; right: 4px; .icon-checkmark-footer(); font-weight: normal; text-indent: 1px; padding-top: 0; font-size: 11px; line-height: 11px; .rotate(0); z-index: 1;}
				.i{display: none;}
				.a{display: block;}
				@media (max-width: @t){
					padding: 0 42px 0 16px;
					&:before{font-size: 9px; line-height: 9px;}
				}
			}
		}
		@media (max-width: @tp){order: 3; padding: 5px 0 4px; flex-flow: column;}
	}
	.hellobar-coupon-btn{
		font-size: 16px; line-height: 17px; font-weight: bold; color: #244538; text-transform: uppercase; background: var(--white); flex-grow: 0; flex-shrink: 0; text-decoration: none; position: relative; top: auto; right: auto; width: auto; height: 48px; padding: 0 29px 0 59px; display: flex; align-items: center; justify-content: center; border-radius: 24px; cursor: pointer;
		&:before{.pseudo(40px,40px); background: #4F2672; top: 4px; left: 4px; border-radius: 200px; display: flex; align-items: center; justify-content: center; .icon-arrow-light(); font: 14px/14px var(--fonti); text-indent: -2px; color: var(--white); font-weight: bold; padding-top: 2px; .rotate(180deg);}
		.a{display: none;}
		@media (max-width: @t){
			font-size: 14px; height: 40px; padding: 0 21px 0 47px;
			&:before{width: 32px; height: 32px; font-size: 11px; line-height: 11px; padding-top: 1px;}
		}
		@media (max-width: @tp){order: 1;}
	}
	.activated-coupon-note{
		display: none; font-size: 14px; line-height: 18px; color: var(--white); margin-right: 16px; text-align: right; max-width: 160px;
		@media (max-width: @l){margin-right: 12px;}
		@media (max-width: @t){font-size: 12px; line-height: 16px; margin-right: 10px;}
		@media (max-width: @tp){order: 2; max-width: unset; padding-top: 6px; margin-right: 0;}
	}

	.hello-bar-timer-cnt{
		flex-shrink: 0; width: auto; position: relative;
		@media (max-width: @tp){width: 100%; order: 1; padding-bottom: 5px;}
	}
	.hello-bar-timer{
		font-size: 20px; line-height: 1; color: var(--white); display: flex; flex: 0 0 auto; margin-left: auto;
		@media (max-width: @t){font-size: 14px;}
		@media (max-width: @tp){justify-content: center;}
		span{
			display: inline-block; font-size: 42px; font-weight: bold; text-align: right;
			@media (max-width: @t){font-size: 28px;}
		}
		.sec span{
			width: 40px;
			@media (max-width: @t){width: 28px;}
		}
		&>div:first-child{
			@media (max-width: @tp){margin-left: 0;}
		}
		&>div{
			margin-left: 16px;
			@media (max-width: @l){margin-left: 12px;}
			@media (max-width: @t){margin-left: 10px;}
		}
	}

	.hello-bar-close{
		display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; background: var(--white); border-radius: 2px; position: absolute; right: 26px; top: 26px; flex-shrink: 0; cursor: pointer; z-index: 1; .transition(opacity);
		&:before{.icon-close(); font: 16px/16px var(--fonti); color: var(--primaryColor); position: absolute;}
		@media (max-width: @l){right: 10px; width: 40px; height: 40px;}
		@media (max-width: @t){
			width: 30px; height: 30px; top: 33px;
			&:before{font-size: 12px; line-height: 12px;}
		}
		@media (max-width: @tp){
			width: 24px; height: 24px; top: 8px; right: 8px;
			&:before{font-size: 10px; line-height: 10px;}
		}
	}
</style>
